export default () => {
  const getThumbnails = ($wrapper) => $('.carousel-thumbnails', $wrapper);
  const isHeroCarousel = ($carousel) => getThumbnails($carousel.parent()).length;

  const updateSlideData = ({ target }) => {
    const $carousel = $(target);
    const $controller = $carousel.siblings('.carousel-controller');
    const $controllerData = $('.carousel-controller__data', $controller);

    const videoWrappers = document.getElementsByClassName('owl-video-wrapper');
    for (var i = 0; i < videoWrappers.length; i++) {
      if (videoWrappers[i] !== null) {
        const children = videoWrappers[i].childNodes;
        children.forEach(function (child) {
          if (child.tagName === 'IFRAME') {
            child.remove();
          }
        });
      }
    }

    setTimeout(() => {
      $('.owl-item.active .carousel-item__data', $carousel)
      .children()
      .clone()
      .appendTo($controllerData.empty());

      $('.carousel-item__title').trunk8({ lines: 2 });
      $('.carousel-item__caption').trunk8({ lines: 3 });
    }, 10);
  };

  const buildThumbnails = ($carousel) => {
    const $thumbnails = $('.carousel-thumbnails', $carousel.parent());
    if ($thumbnails.length) {
      const images = [];
      $('.owl-item', $carousel).each((itemIndex, item) => {
        const thumbnail = item.querySelector('.owl-video-tn, .carousel-item__image');
        if (thumbnail.tagName === 'IMG') {
          images.push(thumbnail.getAttribute('src'));
        }
        else {
          images.push(thumbnail.style.backgroundImage.slice(5, -2));
        }
      });

      images.forEach((imagePath, index) => {
        const $thumbnail = $(`<div class="carousel-thumbnail"><img class="carousel-thumbnail__image" src="${imagePath}"/></div>`);
        $thumbnail.appendTo($thumbnails);
        $thumbnail.data('index', index).on('click', () => {
          $carousel.trigger('to.owl.carousel', index);
        });
      });

      $carousel.trigger('translate.owl.carousel');
    }
  };

  const updateVideoHeight = ({ target }) => {
    const $images = $('.carousel-item img', target);
    const imageHeight = [...$images].reduce((maxHeight, image) => Math.max(maxHeight, image.getBoundingClientRect().height), 0);
    const $videoFrame = $('.active.owl-video-playing .owl-video-wrapper', target);
    const $thumbnail = $('.owl-video-tn', target);
    if (imageHeight) {
      $thumbnail.css('padding-bottom', imageHeight);
    }
    $('iframe', $videoFrame).height($thumbnail.outerHeight());
  };

  const initializeSlides = ({ target }) => {
    const $carousel = $(target);
    setTimeout(() => {
      updateSlideData({ target });
      buildThumbnails($carousel);
      updateVideoHeight({ target });
    }, 10);
  };

  const showController = ({ target }) => {
    $(target).addClass('video-playing');
  };

  const dimController = ({ target }) => {
    $(target).removeClass('video-playing');
  };

  $('.owl-carousel.carousel').each((carouselIndex, carousel) => {
    const $carousel = $(carousel);
    const $carouselItems = $carousel.find('.carousel-item');
    const singleItem = $carouselItems.length === 1;

    $carousel.toggleClass('carousel--single-item', singleItem).owlCarousel({
      loop: !isHeroCarousel($carousel) && !singleItem,
      dots: !isHeroCarousel($carousel),
      nav: $carousel.hasClass('carousel--hero'),
      items: 1,
      video: true,
      smartSpeed: 500,
      onInitialized: initializeSlides,
      onTranslate: updateSlideData,
      onPlayVideo: showController,
      onStopVideo: dimController,
      onResized: updateVideoHeight,
      mouseDrag: !singleItem,
      touchDrag: !singleItem,
      pullDrag: !singleItem
    });

    const $wrapper = $carousel.parent();
    const $prevButton = $('.carousel-navigation-button__previous', $wrapper);
    const $nextButton = $('.carousel-navigation-button__next', $wrapper);
    $prevButton.on('click', () => {
      $carousel.trigger('prev.owl.carousel');
    });

    $nextButton.on('click', () => {
      $carousel.trigger('next.owl.carousel');
    });

    $carousel.on('translate.owl.carousel', ({ relatedTarget = {}, item = {} }) => {
      const $thumbnails = $('.carousel-thumbnail', $wrapper);
      const { index = 0, count = 5 } = item;
      const { options = { loop: false } } = relatedTarget;
      $('.carousel-thumbnail.active', $wrapper).removeClass('active');
      if ($thumbnails.length > index) {
        $($thumbnails.get(index)).addClass('active');
      }
      if (options.loop === false) {
        $prevButton.toggleClass('disabled', (index === 0));
        $nextButton.toggleClass('disabled', (index + 1 === count));
      }
    });
  });
};